var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableLayoutSidebarLeftCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.66663V13.3333M10 6.66663L8.66667 7.99996L10 9.33329M2.66667 3.99996C2.66667 3.64634 2.80714 3.3072 3.05719 3.05715C3.30724 2.8071 3.64638 2.66663 4 2.66663H12C12.3536 2.66663 12.6928 2.8071 12.9428 3.05715C13.1929 3.3072 13.3333 3.64634 13.3333 3.99996V12C13.3333 12.3536 13.1929 12.6927 12.9428 12.9428C12.6928 13.1928 12.3536 13.3333 12 13.3333H4C3.64638 13.3333 3.30724 13.1928 3.05719 12.9428C2.80714 12.6927 2.66667 12.3536 2.66667 12V3.99996Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLayoutSidebarLeftCollapse);
export default __webpack_public_path__ + "static/media/tableLayoutSidebarLeftCollapse.7e584832ffdeec0b18b8e1a327ad63fa.svg";
export { ForwardRef as ReactComponent };